
import {Component} from './base';
import { MPStyle } from '@tomvlk/ts-maniaplanet-formatter';


export class NicknameComponent extends Component {
  public static shouldLoad() {
    return $('.nickname').length > 0;
  }

  public load() {
    // Parse and format nicknames.
    $('.nickname').each((idx, element) => {
      $(element).html(MPStyle($(element).text()));
    });
  }
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/components/nickname.ts